module.exports = __webpack_public_path__ + "static/media/durham.2f7107c4.png";